import React from "react";
import { Row, Box } from "jsxstyle";
import get from "lodash/get";
import omit from "lodash/omit";
import PrivateLayout from "components/PrivateLayout";
import Heading from "components/Heading";
import Separator from "components/Separator";
import Pagination from "components/Pagination";
import Button from "components/Button";
import Card from "components/Card";
import useAsync from "hooks/useAsync";
import useUrlParams from "hooks/useUrlParams";
import useToast from "hooks/useToast";
import loadABSService from "services/abs/loadABSService";
import ABSFilters from "./ABSFilters";
import ABSTable from "./ABSTable";
import AddButton from "components/AddButton";
import pickBy from "lodash/pickBy";

const defaultParams = {
  page: 1,
  size: 20,
  order_by: "pricing_date",
  order_direction: "DESC",
};

function ABSListScreen({ history }) {
  const { showError } = useToast();

  const [params, setParams] = useUrlParams(defaultParams);

  const [fetch, pending, data, error] = useAsync({
    promiseFn: loadABSService,
    params,
    eager: true,
  });

  React.useEffect(() => {
    if (error) {
      showError("Error loading ABS");
    }
  }, [error, showError]);

  return (
    <PrivateLayout>
      <Row alignItems="center">
        <Heading size="md">ABS</Heading>
        <Separator />
        <AddButton onClick={() => history.push("/abs/new")} />
      </Row>
      <Separator />
      <Card style={{ flexGrow: 1 }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          flexWrap="wrap"
        >
          <Box flex="1">
            <ABSFilters
              currentFilters={omit(params, ["page", "size"])}
              onChange={(newFilters) => {
                setParams({
                  ...pickBy(newFilters),
                  ...defaultParams,
                });
              }}
            />
          </Box>
          <Box flex="0 0 150px">
            <Button
              icon="cog"
              text="Configure Table"
              onClick={() => history.push("/abs/table-configuration")}
            />
          </Box>
        </Box>
        <Separator />
        <ABSTable
          onSortChange={(sortObject) =>
            setParams({
              ...params,
              ...pickBy(sortObject),
              page: 1,
            })
          }
          onReload={() => fetch({ params })}
          data={get(data, "data", [])}
          pending={pending}
        />
        <Separator />
        {!pending && (
          <Row justifyContent="flex-end">
            <Pagination
              page={params.page}
              size={params.size}
              total={data.total}
              onChange={({ page }) => setParams({ ...params, page })}
            />
          </Row>
        )}
      </Card>
    </PrivateLayout>
  );
}

export default ABSListScreen;
